"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeUsers_de_de = void 0;
function backofficeUsers_de_de() {
    return {
        "backoffice.users.title": "Benutzer",
        "backoffice.users.registeredat": "Registriert seit",
        "backoffice.users.subtitle": "Hier können Benutzer in Firmen und in dazugehörige Projekte eingeladen werden.",
        "backoffice.users.edit.title": "Benutzer bearbeiten",
        "backoffice.users.permissionstring": "Berechtigungen",
        "backoffice.users.projects": "Projekte",
        "backoffice.users.project": "Projekt",
        "backoffice.users.name": "Name",
        "backoffice.users.company": "Firma",
        "backoffice.users.mail": "E-Mail",
        "backoffice.users.mailvalidated": "E-Mail bestätigt",
        "backoffice.users.mailnotvalidated": "E-Mail nicht bestätigt",
        "backoffice.users.me": "ich",
        "backoffice.users.invite": "Einladen",
        "backoffice.users.permissions.read": "Lesen",
        "backoffice.users.permissions.write": "Schreiben",
        "backoffice.users.permissions.admin": "Administrator",
        "backoffice.users.permissionmanagement.deleteheader": "Berechtigung entfernen",
        "backoffice.users.permissionmanagement.deletemessage": "Möchten Sie die Berechtigung für Person wirklich entfernen?",
        "backoffice.users.permissionmanagement.add": "Berechtigung hinzufügen",
        "backoffice.users.management.title": "Mitarbeiter",
        "backoffice.users.invitations.title": "Einladungen",
        "backoffice.users.invitations.subtitle": "Übersicht aller in Ihr Unternehmen und Ihre Projekte eingeladenen Personen",
        "backoffice.users.invitations.activeinvites": "Offene Einladungen",
        "backoffice.users.invitations.inactiveinvites": "Angenommene Einladungen",
        "backoffice.users.invitations.invitedate": "Wann",
        "backoffice.users.invitations.inviteremail": "Wer",
        "backoffice.users.invitations.targetemail": " Wen",
        "backoffice.users.invitations.company": "Firmen-Rechte",
        "backoffice.users.invitations.permissions": "Projekt-Rechte",
        "backoffice.users.invitations.project": "Projekt",
        "backoffice.users.invitations.companyinvitation": "Einladung nur in die Firma. Keine Rechte für Projekte.",
        "backoffice.users.invitations.noprojectpermission": "Einsicht in Projekt nicht erlaubt.",
        "backoffice.users.invitations.buttons.delete": "Löschen",
        "backoffice.users.invitations.buttons.resend": "Erneut versenden",
        "backoffice.users.invitations.empty.title": "Keine ausstehenden Einladungen",
        "backoffice.users.invitations.empty.message": "An dieser Stelle werden ausstehende Einladungen angezeigt. Fang einfach an, dein Team einzuladen.",
        "backoffice.users.invitations.invitemessage": "Sie haben eine Einladung erhalten von Benutzer ''${name}'' der Firma ''${company}'' ${project}",
        "backoffice.users.invitations.fortheproject": " für das Projekt ''",
        "backoffice.users.invitations.errors.sourceusernotfound": "Der einladende Benutzer wurde nicht gefunden!",
        "backoffice.users.invitations.errors.missingpermissions": "Sie können nur Personen in Firmen oder Projekte einladen, in denen Sie Administrator sind.",
        "backoffice.users.editprofile.title": "Profildaten bearbeiten",
        "backoffice.users.editprofile.confirmresendverifymailatsave.title": "E-Mail nicht bestätigt",
        "backoffice.users.editprofile.confirmresendverifymailatsave.message": "Die E-Mail Adresse dieses Kunden ist noch nicht bestätigt. Möchten Sie den Bestätigungslink erneut versenden?",
        "backoffice.users.editprofile.confirmresendverifymail.title": "Verfizierungsmail",
        "backoffice.users.editprofile.confirmresendverifymail.message": "Möchten Sie den Bestätigungslink erneut versenden?",
        "backoffice.users.passwordreset.title": "Passwort zurücksetzen",
        "backoffice.users.passwordreset.message": "Möchten Sie das Passwort von ${username} wirklich zurücksetzen? Der Benutzer erhält hierfür eine E-Mail mit einem Link zum Zurücksetzen des Passworts.",
        "backoffice.users.passwordreset.titleconfirmation": "E-Mail verschickt",
        "backoffice.users.passwordreset.messageconfirmation": "Die E-Mail zum Zurücksetzen des Passworts wurde erfolgreich verschickt.",
        "backoffice.users.passwordreset.noredirecturl.title": "Keine Weiterleitungs-URL konfiguriert",
        "backoffice.users.passwordreset.noredirecturl.message": "Für Ihr Projekt ist keine Weiterleitungs-URL konfiguriert. Bitte melden Sie sich beim Support, damit wir eine für Sie erstellen können.",
        "backoffice.users.passwordreset.noredirecturl.contact": "Support kontaktieren",
        "backoffice.users.passwordreset.noredirecturl.moreinfo": "Weitere Informationen:"
    };
}
exports.backofficeUsers_de_de = backofficeUsers_de_de;
